var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { filter } from 'rxjs/operators';
import { compileUrl, handleActionResponse } from '../services/actions';
import { Container } from '../services/di';
var DynamicScan = /** @class */ (function (_super) {
    __extends(DynamicScan, _super);
    function DynamicScan(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: null,
            validateStatus: null,
            help: null
        };
        return _this;
    }
    DynamicScan.prototype.componentDidMount = function () {
        var _this = this;
        this.refreshValue();
        this.props.dataState.pathChange
            .pipe(filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            validateStatus: null,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            validateStatus: 'error',
            help: JSON.stringify(error.constraints)
        }); });
        if (this.props.control.viewportListen) {
            this.listener = function (event) { return _this._handleKeyPress(event); };
            window.addEventListener('keypress', this.listener, true);
        }
    };
    DynamicScan.prototype.confirmInput = function () {
        var _this = this;
        if (this.props.control.endpoint) {
            Container.http.get(compileUrl(this.props.control.endpoint, this.props.dataState, {
                '$value': this.state.value
            }))
                .then(function (value) {
                if (value.$action) {
                    handleActionResponse(value);
                }
                else {
                    if (value && value.length > 0) {
                        if (value.length == 1) {
                            _this.setValue(value[0]);
                        }
                        else {
                            alert('MULTIPLE');
                        }
                    }
                    else {
                        alert('Položka nenalezena');
                    }
                }
            });
        }
        else {
            this.setValue(null);
        }
    };
    DynamicScan.prototype.setValue = function (value) {
        this.setState({
            value: value
        });
        this.props.dataState.set(this.props.control.path, value, {
            sender: this
        });
    };
    DynamicScan.prototype.refreshValue = function () {
        this.setState({
            value: this.props.dataState.get(this.props.control.path)
        });
    };
    DynamicScan.prototype.render = function () {
        if (this.props.control.viewportListen) {
            return React.createElement("div", null);
        }
        else {
            return React.createElement("div", null);
        }
    };
    DynamicScan.prototype._handleKeyPress = function (event) {
        var char = String.fromCharCode(event.which);
        if (event.key != 'Enter') {
            this.setState({
                value: this.state.value ? this.state.value + char : char
            });
        }
        else {
            this.confirmInput();
            this.setState({
                value: null
            });
        }
    };
    return DynamicScan;
}(React.Component));
export default DynamicScan;
//# sourceMappingURL=Scan.js.map